import { render, staticRenderFns } from "./Integration.vue?vue&type=template&id=b61c85f6&scoped=true&"
import script from "./Integration.vue?vue&type=script&lang=js&"
export * from "./Integration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61c85f6",
  null
  
)

export default component.exports